import * as types from "redux/types";


const initialState = {
 
};


const indexReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_DASHBOARDVIEW: {
      const { prop, value } = payload;
      return {
        ...state,
        [prop]: value,
      };
    }
    default:
      return state;
  }
};



export default indexReducer;
